// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pp-0";
export var animationContainer = "_pp-1";
export var itemPrice = "_pp-a";
export var itemizedContent = "_pp-9";
export var itemizedHeader = "_pp-7";
export var itemizedRow = "_pp-8";
export var itemizedSection = "_pp-6";
export var modalContent = "_pp-2";
export var orderName = "_pp-3";
export var refundOption = "_pp-4";
export var refundOptionsContainer = "_pp-5";
export var shippingLabel = "_pp-b";
export var totalRow = "_pp-c";